// extracted by mini-css-extract-plugin
export default {"Cennik":"Cennik_Cennik__hJAEa","content":"Cennik_content__YVwRX","miniRiadok":"Cennik_miniRiadok__3oksh","miniPar":"Cennik_miniPar__-q6C1"};